import BaseApi from './baseApi';
import INotificationsInOutbound from '../models/INotificationsInOutbound';
import moment from 'moment';

export default class DashboardApi extends BaseApi {
    constructor() {
        super("dataaccess", "Dashboard");
    }

    async GetOutboundsToday(idCompany: string) : Promise<INotificationsInOutbound[]> {
        let json : string = this.getJsonReadOutboundsToday(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: INotificationsInOutbound[] = [];
            outbounds = response.data as INotificationsInOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsToday(idCompany : string) : Promise<INotificationsInOutbound[]> {
        let json : string = this.getJsonReadInboundsToday(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outbounds: INotificationsInOutbound[] = [];
            outbounds = response.data as INotificationsInOutbound[];
            return outbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    private getJsonReadOutboundsToday(idCompany : string) : any {
        const json = {
            "fields": [{
                "Item1": "Outbounds",
                "Item2": "id as id"
            }, {
                "Item1": "Outbounds",
                "Item2": "code"
            }, {
                "Item1": "ListStatusOutbounds",
                "Item2": "name as statusname"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination"
            }],
            "tables": [{
                "Item1": "Outbounds"
            }, {
                "Item1": "ListStatusOutbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Outbounds",
                "Item2": "idStatus",
                "Item3": "ListStatusOutbounds",
                "Item4": "Id"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Outbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Outbounds",
                "Item2": "DateOut",
                "Item3": "=",
                "Item4": moment(new Date()).format('YYYY-MM-DD'),
                "Item5": "AND"
            }, {
                "Item1": "(Outbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Outbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadInboundsToday(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Inbounds",
                "Item2": "id as id"
            }, {
                "Item1": "Inbounds",
                "Item2": "code"
            }, {
                "Item1": "ListStatusInbounds",
                "Item2": "name as statusname"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination"
            }],
            "tables": [{
                "Item1": "Inbounds"
            }, {
                "Item1": "ListStatusInbounds"
            }, {
                "Item1": "Customers"
            }],
            "joins": [{
                "Item1": "Inbounds",
                "Item2": "idStatus",
                "Item3": "ListStatusInbounds",
                "Item4": "Id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "DateIn",
                "Item3": "=",
                "Item4": moment(new Date()).format('YYYY-MM-DD'),
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }
}
